const AirportCustoms = () => {
  return (
   
    <div>
    
    <div className="flex flex-col justify-center  gap-1 max-w-[50rem] mx-auto pl-[2rem] pr-[2rem]">
      <h1 className="text-[20px] font-bold">Airport Customs</h1>
     <p>
      TCS can help shippers, receivers, organisations and enterprises seamlessly comply with physical 
      characteristics, configurations and material handling standards and regulations that govern air 
      cargo industry. Our operational procedures, best practices and performance standards ensure timely 
      clearance of shipments from customs.
      </p>

     
    </div>
  </div>
  );
};
  
export default AirportCustoms;
  